import ActivityTags from './activityTags.js';
export default ActivityTags;
